// extracted by mini-css-extract-plugin
module.exports = {"section":"RelatedEvents_section__3HXen","header":"RelatedEvents_header__3zwn0","title":"RelatedEvents_title__NYj0G","description":"RelatedEvents_description__2xQmE"};